import { useParams, useNavigate } from 'react-router';
import { useEffect, useState } from 'react';

import Form from '../components/inputs/Form';
import Input from '../components/inputs/Input';
import Rating from '../components/Rating';
import useFetch from '../hooks/useFetch';
import { useNotifications } from '../contexts/NotificationContext';

import './RatingPage.scss';
import Checkbox from '../components/inputs/Checkbox';

export default function RatingPage() {

    const navigate = useNavigate();
    const { path } = useParams();

    // notifications
    const { addNotification } = useNotifications();

    // request booking information
    const [booking, setBooking] = useState({});
    const request = {
        booking: {
            endpoint: `/api/v1/bookings/${path}`,
            method: 'GET'
        },
        allowRating: {
            endpoint: `/api/v1/bookings/${path}/rate`,
            method: 'GET'
        }
    }
    const [data, loading, error] = useFetch(request);

    useEffect(() => {

        let allowRating = false;
        if (data.allowRating && data.allowRating.data) {
            allowRating = data.allowRating.data.allow_rating == true;
            if (!allowRating) {
                navigate('/hub');
                addNotification('Je hebt voor deze activiteit al eens een review geschreven. Dit kan maximaal één keer.');
            }
        }

        if (data.booking && allowRating) {
            if ('error' in data.booking) {
                navigate('/hub');
            } else {
                setBooking(data.booking.data);
            }
        }

    }, [loading]);

    return (

        <main
            id="rating">

            <div className="container">

                <div className="form-container">

                    <h3>Review schrijven.</h3>
                    <p>Laat ons weten wat je vond van '{booking.title}' bij {booking.location_name}.</p>

                    <Form
                        id="rating-form"
                        action={`/api/v1/bookings/${path}/rate`}
                        submitBtnText="Opslaan"
                        submitCallback={(e, data) => {
                            if ('data' in data) {
                                addNotification('Je review is toegevoegd. Dank je voor het schrijven!');
                                navigate('/hub');
                            }
                        }}
                    >

                        <Rating
                            input
                            invert
                            />

                        <Input
                            name="title"
                            type="text"
                            placeholder="Titel van de ervaring"
                            maxLength="50"
                            required
                            />

                        <Input
                            name="message"
                            type="text"
                            rows="4"
                            placeholder="Beschrijving van de ervaring"
                            maxLength="250"
                            required
                            multiline
                            />

                        <Checkbox
                            id="anonymous-review"
                            label="Plaats anoniem"
                            name="anonymous"
                            icon={<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M6 8v-2c0-3.313 2.687-6 6-6 3.312 0 6 2.687 6 6v2h-2v-2c0-2.206-1.795-4-4-4s-4 1.794-4 4v2h-2zm-3 2v14h18v-14h-18z"/></svg>}
                        />

                    </Form>

                </div>

            </div>

        </main>

    );

}